<template>
    <div>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-default">
            </div>
            <div class="container shape-container pt-md">
                <div class="row text-center justify-content-center">
                    <div class="col-12">
                        <div class="checkout-steps">
				            <ul>
				              <li class="identificacao done"><i></i> Identificação</li>
				              <li class="midias" :class="[{'active': stepFormato,'done': stepContribuicao || stepConfirmacao}]"><i></i> Formato</li>
				              <li class="contribuicao" :class="[{'active': stepContribuicao,'done': stepConfirmacao}]"><i></i> Contribuição</li>
				              <li class="conclusao" :class="[{'active': stepConfirmacao}]"><i></i> Confirmação</li>
				            </ul>
				        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section">
        	<div class="container">
	        	<div class="row justify-content-center" v-if="stepFormato">
	        		<div class="col-lg-6">
	        			<div class="card mb-3">
	        				<div class="card-body">
	        					<h5 class="mb-3">Escolha o Formato</h5>
							    <ul class="list-group">
							    	<SlideYUpTransition :duration="500" group>
							    	<li class="list-group-item" :key="1">
							    		<base-radio name="digital" class="" v-model="radio.formato">
									        Mídia Digital
									    </base-radio>
									    <v-select
					                      class="form-control mt-3"
					                      :disabled="radio.formato !== 'digital'"
					                      v-show="radio.formato === 'digital'"
					                      v-model="pedido.formato"
					                      label="name"
					                      :reduce="formato => formato.id"
					                      placeholder="Qualidade Desejada"
					                      :options="formatos"
					                    />
										<SlideYUpTransition>
											<div class="alert alert-info mt-3" role="alert" v-if="radio.formato == 'digital'">
												<strong>Importante</strong> - O formato <strong>ISO</strong> é uma cópia fiel do DVD, porém necessita ser emulado ou gravado para ser reproduzido. O formato <strong>MP4</strong> já está pronto para assistir no computador, na TV ou no celular.
											</div>
										</SlideYUpTransition> 
							    	</li>
							    	<li class="list-group-item" :key="2" v-if="$store.state.catalog.correios">
							    		<base-radio name="fisica" class="" v-model="radio.formato">
									        Mídia Física
									    </base-radio>
									    <v-select
					                      class="form-control mt-3"
					                      :disabled="radio.formato !== 'fisica'"
					                      v-show="radio.formato === 'fisica' && enderecos.length"
					                      v-model="pedido.endereco"
					                      label="nome"
					                      :reduce="endereco => endereco.id"
					                      placeholder="Endereço para Envio"
					                      :options="enderecos"
					                    />
					                    <base-button type="warning" v-if="radio.formato === 'fisica'" size="sm" class="d-inline-block mt-3" @click="$router.push('/perfil/enderecos/novo')">
						                  Cadastrar Endereço
						                </base-button>
							    	</li>
							    	</SlideYUpTransition>
							    </ul>    					
	        				</div>
	        			</div>
	        		</div>
	        		<div class="col-lg-6">
	        			<order-detail></order-detail>
	        		</div>
	        		<div class="col-12">
	        			<div class="d-table w-100 mb-3">
			              <base-button type="secondary" class="d-inline-block" @click="$router.push('/sacola')">
			                Sacola de Títulos
			              </base-button>
		                <base-button type="primary" :disabled="$wait.is('order.calc.shipping')" class="d-inline-block float-right" @click="goToPayment()">
		                  Continuar
		                </base-button>
			            </div>
	        		</div>
	        	</div>
	        	<div class="row justify-content-center" v-if="stepContribuicao">
	        		<div class="col-lg-6">
	        			<div class="card mb-3">
	        				<div class="card-body">
	        					<h5 class="mb-3">Método de Contribuição</h5>
							    <ul class="list-group">
							    	<SlideYUpTransition :duration="500" group>
							    	<li class="list-group-item" :key="1">
							    		<base-radio name="deposito" class="" v-model="radio.pagamento">
									        Depósito Bancário
									    </base-radio>
							    	</li>
									<li class="list-group-item" :key="4" v-if="$store.state.catalog.pix">
							    		<base-radio name="pix" class="" v-model="radio.pagamento">
									        Pix
									    </base-radio>
							    	</li>
									
							    	<li class="list-group-item" :key="2">
							    		<base-radio name="boleto" class="" v-model="radio.pagamento">
									        Boleto Bancário
									    </base-radio>
							    	</li>
							    	<li class="list-group-item" :key="3">
							    		<base-radio name="cartao" class="" v-model="radio.pagamento">
									        Cartão de Crédito
									    </base-radio>
							    	</li>
							    	</SlideYUpTransition>
									<SlideYUpTransition>
										<div class="alert alert-info mt-3" role="alert" v-if="radio.pagamento == 'boleto' && $store.state.catalog.boleto > 0">
											<strong>Aviso</strong> - O pagamento via boleto terá um acréscimo de <strong v-html="returnCurrency(parseFloat($store.state.catalog.boleto))"></strong> no total do pedido.
										</div>
									</SlideYUpTransition> 
							    </ul>        					
	        				</div>
	        			</div>
	        		</div>
	        		<div class="col-lg-6">
	        			<order-detail></order-detail>
	        		</div>
	        		<div class="col-12">
	        			<div class="d-table w-100 mb-3">
			              <base-button type="secondary" class="d-inline-block" @click="$router.push('/checkout/formato')">
			                Escolher Formato
			              </base-button>
		                <base-button type="success" :disabled="$wait.is('order.finalize.payment')" class="d-inline-block float-right" :icon="{'fa fa-circle-o-notch fa-spin': $wait.is('order.finalize.payment'), 'ni ni-basket': !$wait.is('order.finalize.payment')}" @click="finalizeCheckout()">
		                  Finalizar
		                </base-button>
			            </div>
	        		</div>
	        	</div>
	        	<div class="row justify-content-center" v-if="stepConfirmacao">
	        		<div class="col-12 text-center">
	        			<h2 class="display-3 mb-5">Confirmação do Pedido</h2>
	        		</div>
	        		<div class="col-lg-6 mb-4 text-center">
	        			<b-img center src="img/checkout/order-complete-smile.svg" width="120" height="120"></b-img>
	        			<h4 class="text-center mt-3">Pedido Confirmado</h4>
						<p v-if="order_return_paymentmethod">
							Você receberá os dados para o pagamento do seu pedido via depósito através do seu e-mail de cadastro. <strong>Confira a pasta "lixo eletrônico" do seu e-mail caso não receba a mensagem na caixa de entrada.</strong> Se desejar pagar via cobrança do MercadoPago, entre em contato conosco para solicitar a cobrança.
						</p>
						<div v-if="orderState.pix_qrcode">
							Pague agora com Pix<br>
							<img v-lazy="orderState.pix_qrcode" style="max-width: 100%;">
							<div class="lazyOverlay">
								<img src="img/tail-spin.svg">
							</div>
						</div>
	        			<router-link :to="{ name: 'user-profile-order-detail', params: { order_id: order_uuid }}" v-if="order_uuid">
	        			<base-button type="secondary" class="d-inline-block mt-2">
			               Visualizar Pedido
			            </base-button>
			            </router-link>
			            <base-button type="success" class="d-inline-block mt-2 ml-2" v-if="external_checkout_init" @click="redirectPay(external_checkout_init)">
			               Pagar Agora
			            </base-button>
	        		</div>
	        		<div class="col-lg-6">
	        			<b-card no-body>
	        				<h5 slot="header" class="mb-0 text-center">Dados do Pedido</h5>
	        				<b-list-group flush>
		        				<b-list-group-item class="flex-column align-items-start">
								    <div class="d-flex w-100 justify-content-between">
								      <strong>Solicitado em</strong>
								      <span>{{orderState.solicitado_em}}</span>
								    </div>
								</b-list-group-item>
								<b-list-group-item class="flex-column align-items-start">
								    <div class="d-flex w-100 justify-content-between">
								      <strong>Formato</strong>
								      <span>{{(orderState.formato_midia == null) ? 'Mídia Física' : 'Mídia Digital'}}</span>
								    </div>
								</b-list-group-item>
								<b-list-group-item class="flex-column align-items-start">
								    <div class="d-flex w-100 justify-content-between">
								      <strong>Forma de Contribuição</strong>
								      <span>{{orderState.metodo_pagamento}}</span>
								    </div>
								</b-list-group-item>
								<b-list-group-item class="flex-column align-items-start" v-if="parseFloat(orderState.frete) > 0.00">
								    <div class="d-flex w-100 justify-content-between">
								      <strong>Frete</strong>
								      <strong>{{returnCurrency(parseFloat(orderState.frete))}}</strong>
								    </div>
								</b-list-group-item>
								<b-list-group-item class="flex-column align-items-start" v-if="parseFloat(orderState.taxas) > 0.00">
								    <div class="d-flex w-100 justify-content-between">
								      <strong>Taxas</strong>
								      <strong>{{returnCurrency(parseFloat(orderState.taxas))}}</strong>
								    </div>
								</b-list-group-item>
								<b-list-group-item class="flex-column align-items-start">
								    <div class="d-flex w-100 justify-content-between">
								      <strong>Total</strong>
								      <strong>{{returnCurrency(parseFloat(orderState.total))}}</strong>
								    </div>
								</b-list-group-item>
		        			</b-list-group>
	        			</b-card>
	        			
	        		</div>
	        	</div>
	        </div>
        </section>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { SlideYUpTransition } from "vue2-transitions";

import vSelect from 'vue-select';

import correios from '@/api/correios';

import { QrCodePix } from 'qrcode-pix';

import mercadopago from '@/api/mercadopago';

import OrderDetail from './components/OrderDetail';

export default {
  name: 'checkout',
  components: {
	SlideYUpTransition,
  	vSelect,
  	OrderDetail
  },
  data() {
    return {
      modal: {
        title: 'Falha na Solicitação!',
        body: 'Por favor, tente novamente mais tarde',
        classe: 'modal-danger',
        icon: 'ni ni-basket', 
        okButton: 'OK',
      },
      radio: {
      	formato: 'digital',
      	pagamento: 'deposito',
      },
      formatos: [
      	{id:1,name:'ISO'},
      	{id:2,name:'MP4/AVI'}
      ],
      payment_methods: {
      	'deposito': 1,
      	'cartao': 2,
      	'boleto': 3,
		'pix': 4
      },
      pedido: {
      	formato: null,
      	endereco: null
      },
      order_user: {},
      external_checkout_init: null,
      order_uuid: ( !this.$route.query.external_reference ) ? null : this.$route.query.external_reference,
	  order_return_paymentmethod: null,
	  order_pix_qrcode: null,
      enderecos: [],
    }
  },
  methods: {
  	...mapActions('cart', [
        'createOrder',
        'loadOrder'
      ]),
    fullCleanCart(){
    	let payload = {
			'endereco': null,
			'valor': null,
			'prazo': null
		};
		this.$store.dispatch('cart/updateShipping', payload);
		this.$store.dispatch('cart/emptyCart');
	},
	gaCommerceSend(){
		let gaTransactionObject = {
			'id': this.orderState.id,
			'revenue': this.orderTotal
		};

		if ( typeof this.orderShipping === 'number' && this.orderShipping > 0 ) {
			gaTransactionObject['shipping'] = this.orderShipping;
		}

		if ( this.orderTaxes > 0 ) {
			gaTransactionObject['tax'] = this.orderTaxes;
		}

		this.$store.state.cart.items.forEach((item) => {
			this.$ga.ecommerce.addItem({
				id: this.orderState.id,
				name: `${item.formato} - ${item.titulo}`,
				sku: item.id,
				category: item.formato,
				price: ( !item.preco ) ? this.getPriceRange.valor : item.preco,
				quantity: '1'
			});
		});

		this.$ga.ecommerce.addTransaction(gaTransactionObject);
		this.$ga.ecommerce.send();
	},
    redirectPay(url){
      window.location = url;
    },
    returnCurrency(value){
      return value.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
    },
    getMercadoPagoBoleto(payment_id){
    	mercadopago.get('/v1/payments/'+payment_id).then(payment => {
    		let data = payment.data;
    		return data.transaction_details.external_resource_url;
    	});
    },
    async finalizeCheckout(){   	
    	/* passo 1: reduzir os items do carrinho ($store.state.cart.items) para uma string CSV */

    	let cartCSV = '';
    	this.$store.state.cart.items.map(item => {
    		cartCSV += item.id+',';
    	});
    	cartCSV = cartCSV.slice(0,-1);
    	
    	let order_payload = {
    		'metodo_pagamento': this.payment_methods[this.radio.pagamento]
    	};

		order_payload['items'] = cartCSV;
		order_payload['taxas'] = parseFloat(0.00);

    	if ( this.radio.formato == 'digital' ){
    		order_payload['formato_midia'] = this.pedido.formato;
    	}else if ( this.radio.formato == 'fisica') {
    		order_payload['endereco_entrega'] = this.pedido.endereco;
    	}else{
    		/* fallback para erro */
    		alert('não foi possível montar seu pedido. confira seus dados e tente novamente.');
    		return false;
    	}

    	if ( this.orderShipping > 0 ) {
    		order_payload['frete'] = this.orderShipping;
		}
		
		if ( this.orderTaxes > 0 ) {
    		order_payload['taxas'] = this.orderTaxes;
    	}

		if ( this.radio.pagamento === 'pix' ) {
			const qrCodePix = QrCodePix({
				version: '01',
				key: this.$store.state.catalog.pix,
				name: 'Alexander Selbach Backes',
				city: 'NA',
				//transactionId: 'Sessão da Tarde',
				message: 'Sessão da Tarde',
				//cep: '00000000',
				value: this.orderTotal,
			});
			qrCodePix.base64().then(qrPix => { 
				order_payload['pix_qrcode'] = qrPix;
				//this.order_pix_qrcode = qrPix;
			});
		}

    	order_payload['total'] = this.orderTotal;
    	this.$wait.start('order.finalize.payment');
    	this.createOrder(order_payload).then(response => {
    		const order = response.data;
    		
            this.$store.dispatch('cart/finishOrder', order).then(response => {
            	if ( this.orderState !== null ){
            	let matrizMPUser = {};
            		switch(order_payload['metodo_pagamento'])
					{
					    case 1:
					    	/* no caso de depósito bancário, já redirecionamos o usuário para a tela de confirmação do pedido */
					    	this.fullCleanCart();
					    	this.order_uuid = this.orderState.id;
							this.order_return_paymentmethod = 1;

							this.gaCommerceSend();

					        this.$router.push({
					        	path: 'confirmacao',
					        	query: { external_reference: this.orderState.id || undefined }
					        	});
					        break;

					    case 2: /* boleto bancário */
					    case 3: /* cartão de crédito */
					        let MPayload = mercadopago.MercadoPagoDefaultPreference;
    						let discs_string = ( this.orderTotalDisks > 1 ) ? this.orderTotalDisks+' discos' : this.orderTotalDisks+' disco';
    						MPayload['items'] = [
						        {
						          "id": this.orderState.id,
						          "title": "Solicitação de Mídias",
						          "currency_id": "BRL",
						          "description": "Total de Discos: "+discs_string,
						          "quantity": 1,
						          "unit_price": parseFloat(this.orderState.total)
						        }
						    ];

						    MPayload['payer'] = {
						    	"name": this.order_user.first_name,
        						"surname": this.order_user.last_name,
        						"email": this.order_user.email
						    };

						    MPayload['external_reference'] = this.orderState.id;

						    MPayload['payment_methods']['default_payment_method_id'] = 'bolbradesco';

						    if ( order_payload['metodo_pagamento'] < 3 ) {
						    	MPayload['payment_methods']['default_payment_method_id'] = 'master';
						    	MPayload['payment_methods']['default_installments'] = 1;
						    }

						    if ( this.orderState.endereco_entrega !== null ){
						    	const addr_filter = this.enderecos.filter(endereco => endereco.id == this.orderState.endereco_entrega);
						    	const chosen_addr = addr_filter[0];
						    	const CEPValue = chosen_addr.cep.replace(/\-/gi,'');
						    	MPayload['payer']['address'] = {
						    		"street_name": chosen_addr.endereco,
          							"street_number": chosen_addr.numero,
          							"zip_code": CEPValue
						    	};
						    }

						    mercadopago.makePreference(MPayload).then(response => {
						    	let preference = response.data;
						    	if ( preference.id ) {
						    		let payload = {
						    			preference_id: preference.id
						    		};
						    		this.axios.patch('v1/order/'+this.orderState.id+'/', payload ).then(response => {
						    			this.external_checkout_init = preference.init_point;
										this.order_uuid = this.orderState.id;
										
										this.gaCommerceSend();

								        this.fullCleanCart();
								        this.$router.push({
								        	path: 'confirmacao',
								        	query: { external_reference: this.orderState.id || undefined }
								        	});
						    		});
						    	}  
						    }).catch(error => {
						    	this.modal.body = 'Não foi possível gerar seu pedido agora. Por favor, tente novamente mais tarde.';
          						this.$store.dispatch('modal/invokeStateModal', this.modal);
						    }).then(response => {
						    	this.$wait.end('order.finalize.payment');
						    });

					        break;
						case 4: /* pix */
							this.fullCleanCart();
					    	this.order_uuid = this.orderState.id;
							this.gaCommerceSend();

					        this.$router.push({
					        	path: 'confirmacao',
					        	query: { external_reference: this.orderState.id || undefined }
					        	});
					        break;

					    default:
					    	/* caso não seja informado o método de pagamento, redirecionar para a sacola */
					        this.$router.push('/sacola');
					        break;
					}            		
            	}
            });
    	});
    },
  	formatoOrder(){
  		return ( (this.pedido.formato !== null && this.radio.formato == 'digital') && (this.pedido.endereco !== null && this.radio.formato == 'fisica') ) ? true : false;
  	},
  	goToPayment(){
  		if ( this.pedido.formato == null && this.radio.formato == 'digital' ){
  			this.modal.body = 'Por favor, selecione o formato da mídia para continuar.';
          	this.$store.dispatch('modal/invokeStateModal', this.modal);
  		}else if( this.pedido.endereco == null && this.radio.formato == 'fisica' ){
  			this.modal.body = 'Por favor, selecione um endereço para continuar.';
          	this.$store.dispatch('modal/invokeStateModal', this.modal);
        }else if( this.pedido.endereco != null && this.radio.formato == 'fisica' && this.$store.state.cart.shipping_address == null){
        	this.modal.body = 'O CEP do endereço selecionado é inválido! Selecione um endereço válido ou escolha outro formato para envio.';
          	this.$store.dispatch('modal/invokeStateModal', this.modal);
  		}else{
  			this.$router.push('/checkout/contribuicao');				
  		}
  	},
  	paymentReturn() {
  		/*const collection_id = this.$route.query.collection_id;
      	if ( collection_id !== undefined ){
      		this.axios.get('/mercadoPagoAPI/v1/payments/'+collection_id).then(response => {
      			if ( response.data.transaction_details ) {
      				console.log(response.data.transaction_details.external_resource_url);
      			}
      		});
      	}*/
  	},
  	calculaFrete(addressID){

  		const priceRange = this.getPriceRange;
      	const freteGratis = priceRange.freteGratis;

  		const pegaCEP = this.enderecos.filter(endereco => endereco.id == addressID);
  		const CEPval = pegaCEP[0].cep;
  		const CEP = CEPval.replace(/\-/gi,'');

  		let orderProductWeight = this.orderTotalDisks * 0.02;
  		if ( orderProductWeight < 0.3 ) orderProductWeight = 0.3;
  		
  		this.$wait.start('order.calc.shipping');

  		correios.calcula_frete(orderProductWeight,CEP).then(frete => {
  			if ( frete.Erro == 0 ) {
  				const valorReplace = frete.Valor.replace(/,/gi,'.');
  				const valorFloat = parseFloat(valorReplace);
  				let payload = {
  					'endereco': addressID,
  					'valor': valorFloat,
  					'prazo': parseInt(frete.PrazoEntrega)
  				};
  				if ( freteGratis == true ){
  					payload['valor'] = 0.00;
  				}
  				this.$store.dispatch('cart/updateShipping', payload);
  			}else {
  				let payload = {
  					'endereco': null,
  					'valor': null,
  					'prazo': null
  				};
  				this.$store.dispatch('cart/updateShipping', payload);
  				this.modal.body = 'Não foi posível calcular o frete pois o CEP do endereço informado é inválido.';
      			this.$store.dispatch('modal/invokeStateModal', this.modal);
  			}
  		}).catch(error => {
  			this.modal.body = 'Não foi posível calcular o frete. Sistema dos Correios fora do ar.';
  			this.$store.dispatch('modal/invokeStateModal', this.modal);
  		}).then(response => {
  			this.$wait.end('order.calc.shipping');
  		});
  	},
  	async loadAddresses() {
      if ( !this.enderecos.length ) {
        this.axios.get('/v1/users/me/address/')
        .then(response => {
          this.enderecos = response.data;
        });
      }
    },
    async loadUserOrderInfo() {
        this.axios.get('/v1/users/me/').then(response => {
        	this.order_user = response.data;
        });
    },
  },
  computed: {
    ...mapGetters('cart', [
        'orderTotalDisks',
        'getPriceRange',
        'orderShipping',
        'orderSubTotal',
		'orderTotal',
		'orderTaxes',
        'orderState'
      ]),
      stepFormato() {
      	return this.$route.params.step === 'formato';
      },
      stepContribuicao() {
      	return this.$route.params.step === 'contribuicao';
      },
      stepConfirmacao() {
      	return this.$route.params.step === 'confirmacao';
      }
  },
  watch: {
	  'radio.pagamento': function(value){
		  let confirmationCheck = (value == 'boleto' && this.$store.state.catalog.boleto > 0) ? this.$store.state.catalog.boleto : parseFloat(0.00);
		  this.$store.dispatch('cart/updateTaxes',confirmationCheck);
	  },
	  'radio.formato': function(value){
  		if ( value == 'digital' ) {
  			if ( this.pedido.formato !== null ) {
  				let payload = {
					'endereco': null,
					'valor': 0.00
				};
				this.$store.dispatch('cart/updateShipping', payload);
  			}
  		}else if ( value == 'fisica' ) {
  			if ( this.pedido.endereco !== null ) {
  				this.calculaFrete(this.pedido.endereco);
  			}
  		}
  	},
  	'pedido.endereco': function(value){
  		if ( value !== null ) {
  			this.calculaFrete(value);
  		}else {
  			let payload = {
  				'endereco': null,
  				'valor': null
  			};
  			this.$store.dispatch('cart/updateShipping', payload);
  		}
  	},
  	'pedido.formato': function(value){
  		let payload = {
			'endereco': null,
			'valor': 0.00
		};
		this.$store.dispatch('cart/updateShipping', payload);
  	}
  },
  beforeRouteEnter(to, from, next) {
  	const aceitos = ['formato','contribuicao','confirmacao'];
  	let etapaCheckout = aceitos.includes(to.params.step);
  	//let internalOrderKey = to.query.external_reference;
  	
  	if ( etapaCheckout == false ) {
  		next('/checkout/formato');
  	}
  	next();
  },
  created() {
  	const formatoOrder = this.formatoOrder();
  	const mpOrderReturn = this.$route.query.external_reference;
  	if ( formatoOrder == false && mpOrderReturn == undefined ) {
  		this.$router.push('/checkout/formato');
  	}
  	if ( mpOrderReturn == undefined ) {
  		this.loadAddresses();
  	}else{
  		this.$store.dispatch('cart/loadOrder', mpOrderReturn);
  		this.fullCleanCart();
  	}
  	this.loadUserOrderInfo();
  },
  mounted() {
  	this.paymentReturn();
  }
};
</script>
<style lang="scss" scoped>
	$default-gray: #525f7f;
	$primary: #2dce89;

	.modal .ni-basket {
        font-size: 5em !important;
    }

	.checkout-steps {
		width: 100%;
		display: table;
		position: relative;

		ul {
			list-style: none;
			position: relative;
			display: table;
			width: 100%;
			padding: 0;
			margin: 0;

			li {
				display: table-cell;
				width: 1%;
				text-align: center;
				padding: 20px 0;
				position: relative;

				&.active, &.done {
					color: #fff;
				}

				&.active {
					font-weight: bold;
				}

				i {
					display: block;
					margin: 0 auto;
					float: none;
					width: 60px;
					height: 60px;
					margin-bottom: 10px;
					font-size: 2.2em;
					z-index: 2;
					text-align: center;
					background-color: $default-gray;
					border-radius: 50%;
					position: relative;
					line-height: 68px;
					&:before {
						width: 35px;
						height: 35px;
						display: block;
						float: none;
						margin: 0 auto;
					}
				}

				&:after {
					content: '';
		      		position: absolute;
				    display: inline-block;
				    background: $default-gray;
				    width: 100%;
				    height: 0.5em;
				    top: 1.25em;
				    left: 50%;
				    z-index: 1;
				    top: 47px;
				}

				&:last-child {
					&:after {
						content: none;
					}
				}

				&.done i {
					color: #fff;
					background-color: $primary;
				}

				&.done:after {
					background: $primary;
				}

				&.active:after {
					background: $default-gray;
				}

				&.active i {
					color: #fff;
					background-color: $primary;
				}

				&.identificacao i:before {
					content: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNSAzNSI+PHBhdGggZD0iTTM1IDE3LjVDMzUgNy45IDI3LjEgMCAxNy41IDBTMCA3LjkgMCAxNy41YzAgNS4xIDIuMiA5LjcgNS43IDEyLjlsLjYuNS4xLjFjLjMuMy42LjUuOS43LjEuMS4yLjEuMy4yLjMuMi43LjUgMSAuNy4xIDAgLjIuMS4yLjFsMS4yLjZoLjFjMS4zLjYgMi43IDEuMSA0LjIgMS4zaC4xYy41LjEuOS4xIDEuNC4yaC4yYy41IDAgLjkuMSAxLjQuMS41IDAgLjkgMCAxLjQtLjFoLjJjLjUgMCAuOS0uMSAxLjQtLjJoLjFjMS41LS4zIDIuOS0uNyA0LjItMS4zIDAgMCAuMSAwIC4xLS4xbDEuMi0uNmMuMS0uMS4yLS4xLjMtLjIuMy0uMi43LS40IDEtLjYuMS0uMS4yLS4yLjMtLjIuMy0uMi42LS40LjgtLjYuMSAwIC4xLS4xLjItLjFsLjYtLjVjMy42LTMuMiA1LjgtNy44IDUuOC0xMi45em0tMzMuNyAwYzAtOC45IDcuMy0xNi4yIDE2LjItMTYuMnMxNi4yIDcuMyAxNi4yIDE2LjJjMCA0LjgtMi4xIDkuMi01LjUgMTIuMWwtLjYtLjMtNS40LTIuN2MtLjUtLjItLjgtLjctLjgtMS4zdi0xLjljLjEtLjIuMy0uMy40LS41LjctMSAxLjMtMi4xIDEuNy0zLjMuOC0uNCAxLjMtMS4yIDEuMy0yLjF2LTIuM2MwLS42LS4yLTEuMS0uNi0xLjV2LTNjMC0uMy4yLTIuMi0xLjItMy43LTEuMi0xLjMtMy4xLTItNS42LTJzLTQuNS43LTUuNiAyYy0xLjMgMS41LTEuMiAzLjQtMS4yIDMuN3YzYy0uNC40LS42IDEtLjYgMS41djIuM2MwIC43LjMgMS40LjkgMS44LjUgMiAxLjYgMy41IDIgNC4xdjEuOGMwIC41LS4zIDEtLjcgMS4ybC01IDIuN2MtLjIuMS0uMy4yLS41LjMtMy4zLTIuOC01LjQtNy4xLTUuNC0xMS45eiIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg==');
				}

				&.midias i:before {
					content: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNSAzNSI+PHBhdGggZD0iTTI3LjQgM2MtMi41LTEuNy01LjItMy03LjEtM0wxOCAxMC41YzEuMy4xIDIuNC41IDMuNCAxLjJsNi04Ljd6TTEyLjggMTcuNWMwIDIuNiAyLjEgNC43IDQuNyA0LjdzNC43LTIuMSA0LjctNC43LTIuMS00LjctNC43LTQuNy00LjcgMi4xLTQuNyA0Ljd6bTQuNy0xLjJjLjYgMCAxLjIuNSAxLjIgMS4ycy0uNSAxLjItMS4yIDEuMmMtLjYgMC0xLjItLjUtMS4yLTEuMiAwLS42LjYtMS4yIDEuMi0xLjJ6bS03IDEuMmMwLTMuNiAyLjYtNi41IDYuMS02LjlMMTUuMi4xQzYuNiAxLjMgMCA4LjYgMCAxNy41YzAgMy43IDEuMSA3IDMuMSA5LjlsOC43LTUuOWMtLjktMS4yLTEuMy0yLjUtMS4zLTR6bTIxLjQtOS45bC04LjcgNS45Yy44IDEuMSAxLjIgMi41IDEuMiA0IDAgMy45LTMuMSA3LTcgNy0xLjUgMC0yLjgtLjUtNC0xLjJsLTUuOSA4LjZjMi44IDEuOSA2LjIgMy4xIDkuOSAzLjFDMjcuMiAzNSAzNSAyNy4yIDM1IDE3LjVjMC0zLjctMS4xLTcuMS0zLjEtOS45eiIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg==');
				}

				&.contribuicao i:before {
					content: url('data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHg9IjAiIHk9IjAiIHZpZXdCb3g9IjAgMCAzNSAzMS43IiB4bWw6c3BhY2U9InByZXNlcnZlIj48c3R5bGU+LnN0MHtmaWxsOiNmZmZ9PC9zdHlsZT48ZyBpZD0ibGF5ZXIxMDEiPjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0zLjIgMzEuNGMtMS4zLS41LTIuNS0xLjgtMy0zLS4yLS43LS4yLTEuNi0uMi0xMi42QzAgMy45IDAgMy44LjMgMyAuNyAyIDIgLjcgMyAuM2MuOC0uMy45LS4zIDEzLjEtLjMgMTIgMCAxMi4yIDAgMTMgLjMuOS4zIDEuOSAxLjIgMi4zIDIuMi4zLjcuMy45LjMgM3YyLjNsLjYuM2MuOS41IDIgMS44IDIuNCAyLjcuMy44LjMuOS4zIDlWMjhsLS40LjhjLS41IDEtMS41IDItMi40IDIuNGwtLjguNEgxNy43Yy0xMy4yLjEtMTMuOC4xLTE0LjUtLjJ6TTMxIDI5LjJjMS4zLS43IDEuNy0xLjQgMS44LTMuNGwuMS0xLjVoLTNjLTMuMyAwLTMuNS0uMS00LjYtMS4xLS44LS44LTEuMi0xLjctMS4yLTIuOXMuNC0yLjEgMS4yLTIuOWMxLjEtMS4xIDEuMy0xLjEgNC42LTEuMWgzbC0uMS0yYy0uMS0xLjctLjEtMi4xLS4zLTIuNi0uMy0uNi0uNy0xLTEuNC0xLjQtLjUtLjItMS4xLS4zLTE0LS4zTDMuNSA5LjhsLS43LS4zLS42LS4zdjkuMWMwIDguNS4xIDkuMS4zIDkuNS41LjkgMS4yIDEuNCAyLjEgMS43LjMuMSA2LjIuMSAxMy4yLjEgMTIuMi0uMSAxMi44LS4yIDEzLjItLjR6bTEuOC05di0xLjlsLTIuNS4xYy0yLjcuMS0zLjEuMS0zLjcuOS0uNC41LS40IDEuNSAwIDIgLjYuOCAxLjEuOSAzLjkuOWgyLjJ2LTJ6TTI5LjUgNS44YzAtMS42LS4xLTItLjMtMi40LS40LS43LTEtMS4xLTEuOS0xLjItLjQgMC01LjctLjEtMTEuOSAwLTExLjEgMC0xMS4xIDAtMTEuNy4zLTEgLjUtMS40IDEuMy0xLjQgMi40IDAgMS4zLjkgMi40IDIuMiAyLjYuMy4xIDYgLjEgMTIuOC4xaDEyLjNsLS4xLTEuOHoiLz48cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjcuNiAyMS4xYy0uMi0uMi0uMy0uNS0uMy0uOHMuMS0uNi4zLS44LjUtLjMuOC0uMy42LjEuOC4zLjMuNS4zLjgtLjEuNi0uMy44LS41LjMtLjguMy0uNi0uMi0uOC0uM3pNNC40IDQuOVYzLjhoMjNWNmgtMjNWNC45eiIvPjwvZz48L3N2Zz4=')
				}

				&.conclusao i:before {
					content: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNSAzNSI+PHBhdGggZD0iTTM0LjQgNy44bC0zLjEtMy4xYy0uNC0uNC0uOS0uNi0xLjUtLjZzLTEuMS4yLTEuNS42TDEzLjQgMTkuNmwtNi42LTYuN2MtLjQtLjQtLjktLjYtMS41LS42cy0xLjEuMi0xLjUuNkwuNiAxNmMtLjQuNC0uNi45LS42IDEuNXMuMiAxLjEuNiAxLjVsOC4yIDguMiAzLjEgMy4xYy40LjQuOS42IDEuNS42czEuMS0uMiAxLjUtLjZsMy4xLTMuMSAxNi4zLTE2LjNjLjQtLjQuNi0uOS42LTEuNS4xLS43LS4xLTEuMi0uNS0xLjZ6IiBmaWxsPSIjZmZmIi8+PC9zdmc+');
				}
			}
		}
	}
</style>
